import React from 'react';
import classNames from 'classnames';
import DetailPageMainView from './DetailPageMainView';
import DetailPageRelativeView from './DetailPageRelativeView';
import ApprovalList from '../Approval/ApprovalList';

import { ExtensionWrap } from '../util/extension';
import * as helper from '../util/helper';

class OnePage extends React.Component {
    constructor(props,context) {
        super(props,context);

    }

    renderMainView(mainViewData) {
        return (
            <ExtensionWrap {...mainViewData} componentMap={this.props.componentMap}>
                <DetailPageMainView {...mainViewData} componentMap={this.props.componentMap} formType={'detailForm'} />
            </ExtensionWrap>
        );
    }

    renderRelativeView() {
         return this.props.onePageData.relativeViewData.map(item => {
              return (
                 <div className='onepage_table_list'>
                     <DetailPageRelativeView
                         query={helper.getQueryObject()}
                         detailPage={this.props.detailPage}
                         {...item}
                         actions={this.props.actions}
                     />
                 </div>
              );
         });
    }


    renderApprovalProcess() {
        const queryObj = helper.getQueryObject();
        if(BSGlobal.application === 'ApprovalCentre' && queryObj.processInstanceId) {
            return (
                <ApprovalList processInstanceId={queryObj.processInstanceId} showTip={this.props.actions.showTip} />
            );
        }
        return null;
    }

    render() {
        return(<div className={classNames('onepage_content')}>
                    {this.renderMainView(this.props.onePageData.mainViewData)}
                    {this.renderRelativeView()}
                    {this.renderApprovalProcess()}
                </div>);
    }
}

export default OnePage;



// WEBPACK FOOTER //
// ./src/components/DetailPage/OnePage.js